import { gql, graphql } from "react-apollo"
import { GetSlidesQuery } from "./withSlides"
import type { Slide, SlideFormViewProps } from "../types"

const MUTATE_CREATE_SLIDE = gql`
  mutation CreateSlide($attractLoopId: ID!, $slide: SlideInput!) {
    createSlide(attractLoopId: $attractLoopId, slide: $slide) {
      id
      title
    }
  }
`

const mutateCreateSlide = graphql(MUTATE_CREATE_SLIDE, {
  name: "mutateCreateSlide",
  options: ({ attractLoopId }: SlideFormViewProps) => ({
    refetchQueries: [{ query: GetSlidesQuery, variables: { attractLoopId } }]
  }),
  props: ({ mutateCreateSlide }) => ({
    createSlide: (attractLoopId: string, slide: Slide) =>
      mutateCreateSlide({
        variables: { attractLoopId, slide }
      })
  })
})

export default mutateCreateSlide



// WEBPACK FOOTER //
// ./src/Slides/queries/mutateCreateSlide.js